let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("01BCB")).then(() => parcelRequire('5aO99'));